var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-export-portal',{staticClass:"p-data-export-portal"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }